import {
   OBTER_CARGOS,
   OBTER_PATIOS,
   OBTER_UNIDADE_LOTACAO,
   SET_GERAR_RELATORIO,
   SET_GERAR_RELATORIO_USU_DELEGACAO,
   SET_OBTER_RELATORIOS,
   SET_REPROCESSAR_RELATORIO
} from './mutations-types'

import {
   ApiGerarRelatorio,
   ApiGerarRelatorioUsuDelegacao,
   ApiObterPatios,
   ApiObterRelatorios,
   ApiObterUnidadeLotacao,
   ApiReprocessarRelatorio
} from '@/api'
import { ApiObterCargos } from '@/api/cargos'

export const ActionObterRelatorios = async ({ commit }, filtros) =>
   await ApiObterRelatorios(filtros)
      .then((response) => commit(SET_OBTER_RELATORIOS, response))
      .catch(() => commit(SET_OBTER_RELATORIOS, null))

export const ActionReprocessarRelatorio = async ({ commit }, idTarefa) =>
   await ApiReprocessarRelatorio(idTarefa)
      .then((response) => commit(SET_REPROCESSAR_RELATORIO, response))
      .catch(() => commit(SET_REPROCESSAR_RELATORIO, null))

export const ActionObterCargos = async ({ commit }) =>
   await ApiObterCargos()
      .then((response) => commit(OBTER_CARGOS, response))
      .catch(() => commit(OBTER_CARGOS, null))

export const ActionObterUnidadeLotacao = async ({ commit }) =>
   await ApiObterUnidadeLotacao()
      .then((response) => commit(OBTER_UNIDADE_LOTACAO, response))
      .catch(() => commit(OBTER_UNIDADE_LOTACAO, null))

export const ActionObterPatios = async ({ commit }, filtros) =>
   await ApiObterPatios(filtros)
      .then((response) => commit(OBTER_PATIOS, response))
      .catch(() => commit(OBTER_PATIOS, null))

export const ActionsGerarRelatorio = async ({ commit }, payload) =>
   await ApiGerarRelatorio(payload)
      .then((response) => commit(SET_GERAR_RELATORIO, response))
      .catch(() => commit(SET_GERAR_RELATORIO, null))

export const ActionsGerarRelatorioUsuDelegacao = async ({ commit }, filtros) =>
   await ApiGerarRelatorioUsuDelegacao(filtros)
      .then((response) => commit(SET_GERAR_RELATORIO_USU_DELEGACAO, response))
      .catch(() => commit(SET_GERAR_RELATORIO_USU_DELEGACAO, null))
